import { HttpService } from 'app/services';
import * as AppActions from 'app/store/actions';
import { parseError } from 'helpers/Error';

export const SET_ANNOUNCEMENT_FILTER = '@ANNOUNCEMENT/SET_FILTER';
export const RESET_ANNOUNCEMENT_FILTER = '@ANNOUNCEMENT/RESET_FILTER';
export const CHANGE_ANNOUNCEMENT_TAB = '@ANNOUNCEMENT/CHANGE_TAB';

export const DELETE_ANNOUNCEMENT = '@ANNOUNCEMENT/DELETE';
export const DELETE_ANNOUNCEMENT_SUCCESS = '@ANNOUNCEMENT/DELETE_SUCCESS';
export const DELETE_ANNOUNCEMENT_FAIL = '@ANNOUNCEMENT/DELETE_FAIL';

export const ACTIVATE_ANNOUNCEMENT = '@ANNOUNCEMENT/ACTIVATE';
export const ACTIVATE_ANNOUNCEMENT_SUCCESS = '@ANNOUNCEMENT/ACTIVATE_SUCCESS';
export const ACTIVATE_ANNOUNCEMENT_FAIL = '@ANNOUNCEMENT/ACTIVATE_FAIL';

export const EXPIRE_ANNOUNCEMENT = '@ANNOUNCEMENT/EXPIRE';
export const EXPIRE_ANNOUNCEMENT_SUCCESS = '@ANNOUNCEMENT/EXPIRE_SUCCESS';
export const EXPIRE_ANNOUNCEMENT_FAIL = '@ANNOUNCEMENT/EXPIRE_FAIL';

export const setAnnouncementFilter = (filter) => ({
  type: SET_ANNOUNCEMENT_FILTER,
  payload: { filter },
});

export const resetAnnouncementFilter = () => ({
  type: RESET_ANNOUNCEMENT_FILTER,
});

export const changeAnnouncementTab = (tab) => ({
  type: CHANGE_ANNOUNCEMENT_TAB,
  payload: tab,
});

export const deleteAnnouncement = (id) => {
  return (dispatch) => {
    HttpService.abort('deleteAnnouncement');
    dispatch({ type: DELETE_ANNOUNCEMENT });
    return HttpService.delete(`/api/announcements/${id}`, { cancelToken: 'deleteAnnouncement' })
      .then(() => {
        dispatch(AppActions.showMessage({ message: 'announcement:DELETE_SUCCESS' }));
        dispatch({ type: DELETE_ANNOUNCEMENT_SUCCESS });
        dispatch(AppActions.dataLoader_reload('GET:Announcements'));
      })
      .catch((err) => {
        const { errorMessages, errorTitle } = parseError(err);
        dispatch({ type: DELETE_ANNOUNCEMENT_FAIL, payload: { message: errorMessages.join('\n') } });
        dispatch(AppActions.createDialogMessage('error', errorTitle, errorMessages));
      });
  };
};

export const activateAnnouncement = (id) => {
  return (dispatch) => {
    HttpService.abort('activateAnnouncement');
    dispatch({ type: ACTIVATE_ANNOUNCEMENT });
    return HttpService.put(`/api/announcements/${id}/activate`, null, { cancelToken: 'activateAnnouncement' })
      .then(() => {
        dispatch(AppActions.showMessage({ message: 'announcement:ACTIVATE_SUCCESS' }));
        dispatch({ type: ACTIVATE_ANNOUNCEMENT_SUCCESS });
        dispatch(AppActions.dataLoader_reload('GET:Announcements'));
      })
      .catch((err) => {
        const { errorMessages, errorTitle } = parseError(err);
        dispatch({ type: ACTIVATE_ANNOUNCEMENT_FAIL, payload: { message: errorMessages.join('\n') } });
        dispatch(AppActions.createDialogMessage('error', errorTitle, errorMessages));
      });
  };
};

export const expireAnnouncement = (id) => {
  return (dispatch) => {
    HttpService.abort('expireAnnouncement');
    dispatch({ type: EXPIRE_ANNOUNCEMENT });
    return HttpService.put(`/api/announcements/${id}/expire`, null, { cancelToken: 'expireAnnouncement' })
      .then(() => {
        dispatch(AppActions.showMessage({ message: 'announcement:EXPIRE_SUCCESS' }));
        dispatch({ type: EXPIRE_ANNOUNCEMENT_SUCCESS });
        dispatch(AppActions.dataLoader_reload('GET:Announcements'));
      })
      .catch((err) => {
        const { errorMessages, errorTitle } = parseError(err);
        dispatch({ type: EXPIRE_ANNOUNCEMENT_FAIL, payload: { message: errorMessages.join('\n') } });
        dispatch(AppActions.createDialogMessage('error', errorTitle, errorMessages));
      });
  };
};
